<template>
	<span>Hi</span>
</template>

<script>
  export default {
    data: () => ({
    })
  }
</script>